<section>
  <app-ice-back-button
    testId="change-user-back-link"
    (click)="finishedChanging.emit()"
    (keydown.enter)="finishedChanging.emit()"
  />
  @if (product.isLoadingExistingSubscriber) {
    <app-spinner />
  } @else {
    <div class="user-information">
      <h4>Endre brukerinformasjon</h4>
      <form [formGroup]="form" (ngSubmit)="onSave()">
        <app-user-definer-step
          [groupName]="groupName"
          [lowerAgeLimit]="lowerAgeLimit"
          [productId]="product.id"
          [subscriber]="product.subscriber"
          [upperAgeLimit]="upperAgeLimit"
        />
        <app-ice-button
          color="primary"
          testId="submit-change-user-button"
          type="submit"
          [disabled]="!(form.dirty && form.valid)"
        >
          Bekreft
        </app-ice-button>
      </form>
    </div>
  }
</section>
